export default __webpack_public_path__ + "static/media/151-graphic-design.80faf553.png";